import { parseHTML } from '../../utils/dom'
import Modal from '../modal/modal'

class CartNotificationPopup extends Modal {
  showProductFromParsedState(parsedState: any, productId: number): void {
    const section = parsedState.sections['cart-notification-popup-content']
    const sectionHTML = parseHTML(section)

    if (this.element) {
      const targetProduct = sectionHTML.querySelector(
        `#CartNotificationPopupItem-${productId}`,
      )
      const content = this.element.querySelector(
        '[data-cart-notification-popup]',
      )

      if (content && targetProduct) {
        const clonedTargetProduct = targetProduct.cloneNode(true)

        content.replaceChildren(clonedTargetProduct)
      }

      this.updateCartCountInHeader(parsedState)

      this.show()
    }
  }

  updateCartCountInHeader(parsedState: any): void {
    const section = parsedState.sections['cart-count']
    const sectionHTML = parseHTML(section)

    const count = document.getElementById('CartCount')
    const stickyCount = document.getElementById('StickyCartCount')
    const newCount = sectionHTML.getElementById('CartCount')

    if (!newCount) {
      return
    }

    const clonedNewCount = newCount?.cloneNode(true)

    if (stickyCount) {
      stickyCount.replaceChildren(...clonedNewCount.childNodes)
    }

    if (count) {
      count.replaceChildren(...clonedNewCount.childNodes)
    }
  }
}

export default CartNotificationPopup
